<template>
  <div ref="source" id="source-view" class="source-preview-inside cat-trans"
       v-html="getContentInfo.sourceStr" />
</template>

<script>
export default {
  name: "SourcePreview",
  data() {
    return {
    };
  },
  props: ["sourceStr"],
  watch: {
    getAppointPreview: {
      handler(val) {
        if (val && val.sourceStr) {
          let domArr = document.querySelectorAll('div[partType = source ][partIndex]')
          domArr.forEach(element => {
            if (element && element.getAttribute('partIndex') && parseInt(element.getAttribute('partIndex')) === parseInt(this.getPartIndex)) {
              element.innerHTML = val.sourceStr
            }
          })
        }
      },
      deep: true
    },
    getSouceInfo: {
      handler(val) {
        if (!!val.sourceTagFragmentVo) {
          let domArr = document.querySelectorAll(`span[type='source'][sid='${val.sentId}']`)
          if (domArr[0]) {
            this.getLoopNode(domArr[0])
          }
          // let atomsArr = val.sourceTagFragmentVo.atoms.filter(item => {
          //   return item.dataType === 'text'
          // })
          // domArr.forEach(element => {
          //   let key = '$' + '{' + element.getAttribute('key') + '}'
          //   atomsArr.forEach(item => {
          //     if (key === item.atomKey) {
          //       element.innerText = item.data
          //     }
          //   })
          // })

        }
      },
      deep: true
    }
  },
  computed: {
    getContentInfo() {
      return this.$store.getters['editor/getFilePreviewContentInfo'];
    },
    //获取原译文修改
    getSouceInfo() {
      return this.$store.getters["editor/getPreviewInfo"].params;
    },
    // 获取指定页码的段落
    getAppointPreview() {
      return this.$store.getters["editor/getAppointPreview"];
    },
    // 获取预览页码
    getPartIndex() {
      return this.$store.getters["editor/getPartIndex"]
    },
  },
  mounted() {
  },
  methods: {
    // 查找出partIndex属性的节点
    getLoopNode(element) {
      if (element && element.parentNode && element.parentNode.nodeName === 'DIV' && element.parentNode.getAttribute('partIndex')) {
        let partIndex = element.parentNode.getAttribute('partIndex')
        if (partIndex) {
          this.$store.dispatch('editor/setWordPreview', partIndex)
        }
        return
      } else {
        this.getLoopNode(element.parentNode)
      }
    }
  }

}
</script>

<style lang="less" scoped>
@import "assets/style.less";
</style>